import {
  AfterContentChecked,
  AfterViewInit,
  Attribute,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChildren,
} from '@angular/core';
import { NamedTemplateDirective } from '../../directives/named-template/named-template.directive';
import { AppIcon } from '../../AppIcon';

type DynamicClass = { [key: string]: boolean };
@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnInit, OnChanges, AfterViewInit, AfterContentChecked {
  AppIcon = AppIcon;

  @Input() class: string;
  @Input() dynClass: DynamicClass = {};

  @Input() skeleton: boolean = false;
  _skeleton: boolean = false;

  @Input() icon: AppIcon;
  _icon: AppIcon;
  ctx = { class: '' };

  @ViewChildren(TemplateRef, { read: NamedTemplateDirective }) iconTemplates: QueryList<NamedTemplateDirective>;
  currentTemplate: TemplateRef<any>;

  constructor(
    @Attribute('class') public cssClass: string = 'h-5 w-5',

    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.ctx.class = this.cssClass;
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.changeDetectorRef.detach();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.icon?.currentValue != changes.icon?.previousValue) {
      if (!changes.icon?.currentValue) {
        this.changeDetectorRef.detectChanges();
      } else {
        this._icon = changes.icon?.currentValue;
        this.updateTemplate();
      }
    } else if (changes.skeleton?.currentValue != changes.skeleton?.previousValue) {
      this._skeleton = changes.skeleton?.currentValue;
      this.changeDetectorRef.detectChanges();
    } else if (changes.class?.currentValue != changes.class?.previousValue) {
      this.cssClass = changes.class?.currentValue;
      this.ctx.class = this.cssClass;
      this.changeDetectorRef.detectChanges();
    } else if (changes.dynClass?.currentValue != changes.dynClass?.previousValue) {
      this.changeDetectorRef.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    this.updateTemplate();
  }

  updateTemplate(): void {
    this.currentTemplate = this.getTemplate(this._icon);
    this.changeDetectorRef.detectChanges();
  }

  getTemplate(templateName: string): TemplateRef<any> {
    return this.iconTemplates?.find((namedTemplate) => namedTemplate.appNamedTemplate === templateName)?.template;
  }

  getDynamicClassString(dynamicClass: DynamicClass): string {
    return Object.keys(dynamicClass)
      .filter((key) => dynamicClass[key])
      .join(' ');
  }

  get classes(): string {
    return `${this.class} ${this.cssClass} ${this.getDynamicClassString(this.dynClass)}`;
  }
}
